import React from 'react';
import { useHistory } from 'react-router-dom';
import ListItem from '../../../../components/lists/list-item/list-item';
import {
  DataVariant,
  ListItemData,
  ListItemDataRow,
} from '../../../../components/lists/list-item/types';
import { formatDate } from '../../../../helpers/date-formatters';
import { formatNumber } from '../../../../helpers/number-formatters';
import {
  Direction,
  Status,
  UnitOrderListItem as ListItemDataInput,
} from '../../../../logic/graphql/types/types.d';
import { Paths } from '../../../../navigation/paths';
import { useIntl } from 'react-intl';

const UnitOrderListItem = (props: {
  listItem: ListItemDataInput;
  style?: React.CSSProperties | undefined;
  mobileHeight?: number;
}): JSX.Element => {
  const intl = useIntl();
  const history = useHistory();

  const handleOnClick = (): void => {
    history.push(Paths.unit_orders + '/' + props.listItem.transaction_code);
  };

  const dataLines1: ListItemDataRow[] = [
    {
      label: intl.formatMessage({ id: 'unitOrders.listItem.pcs' }),
      value: props.listItem.count.toString(),
      variant: DataVariant.gray,
    },
  ];
  if (props.listItem.direction === Direction.Buy) {
    dataLines1.push({
      label: intl.formatMessage({ id: 'unitOrders.listItem.purchaseValue' }),
      value: formatNumber(props.listItem.purchase_value, props.listItem.security.currency.currency),
    });
  }

  const dataLines2: ListItemDataRow[] = [
    {
      label: intl.formatMessage({ id: 'unitOrders.listItem.completedCount' }),
      value: props.listItem.fulfilled_count.toString(),
      variant: DataVariant.gray,
    },
    {
      label: intl.formatMessage({ id: 'unitOrders.listItem.dealPrice' }),
      value: formatNumber(
        props.listItem.deal_price,
        `${props.listItem.security.currency.currency} / db`,
        6,
      ),
    },
  ];

  const detailBlocks = [
    {
      dataLines: dataLines1,
    },
  ];

  if (props.listItem.status === Status.Completed || props.listItem.status === Status.Partial) {
    detailBlocks.push({
      dataLines: dataLines2,
    });
  } else {
    detailBlocks.push({ dataLines: [] });
  }

  const data: ListItemData = {
    status: props.listItem.status,
    iconVisible: false,
    title: props.listItem.security.name,
    titleExtension: intl.formatMessage({ id: 'unitOrders.listItem.securityExtension' }),
    transactionCode: props.listItem.transaction_code,
    detailBlocks,
    date:
      formatDate(props.listItem.validity_start) + ' - ' + formatDate(props.listItem.validity_end),
    direction: props.listItem.direction,
  };

  return (
    <ListItem
      onClick={handleOnClick}
      data={data}
      style={props.style}
      mobileHeight={props.mobileHeight}
    />
  );
};

export default UnitOrderListItem;
